import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { profilesRepository } from "@/repositories/profilesRepository";
import type { ProfileRow, ProfileUpdate } from "@/schemas/profile";

export const profilesKeys = {
  all: ["profiles"] as const,
  list: () => ["profiles", "list"] as const,
};

export function useProfiles() {
  return useQuery<ProfileRow[]>({
    queryKey: profilesKeys.list(),
    queryFn: () => profilesRepository.list(),
  });
}

export function useUpdateProfile(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: ProfileUpdate) => profilesRepository.update(id, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: profilesKeys.all });
    },
  });
}
